import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/svg/apple-download.svg?url")